// import React from "react";
// import { Navigate } from "react-router-dom";
// import getPrivilegeList from "./peday/PrivilegeList";

// const ProtectedRoute = ({ element, privilegeKey }) => {
//   const token = localStorage.getItem("authToken"); // check login
//   const privilege = getPrivilegeList();

//   if (!token) return <Navigate to="/Login" replace />; // not logged in
//   if (privilegeKey && !privilege[privilegeKey]) return <Navigate to="/" replace />; // no privilege

//   return element;
// };

// export default ProtectedRoute;


import React from "react";
import { Navigate } from "react-router-dom";
import getPrivilegeList from "./peday/PrivilegeList";

export default function ProtectedRoute({ children, privilegeKey }) {
  const token = localStorage.getItem("authToken");
  if (!token) return <Navigate to="/login" replace />;

  if (privilegeKey) {
    const privilege = getPrivilegeList() || {};
    if (!privilege[privilegeKey]) return <Navigate to="/blocked" replace />;
  }

  return children;
}